import React from 'react';
import { InboxPage } from './pages/InboxPage';
export function App() {
  return <InboxPage data-id="element-0" />;
}